/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { Route, Routes } from "react-router-dom";
import UserRoute from "./UserRoute";
import MainLayout from "../Layout/MainLayout";
import CategoryManagement from "../Pages/CategoryManagement";
import OfferManagement from "../Pages/OfferManagement";
import UserManagement from "../Pages/UserManagement";
import CouponManagement from "../Pages/CouponManagement";
import ForgotPassword from "../Pages/ForgotPassword";
import ResetPassword from "../Pages/ResetPassword";
import HomePage from "../Pages/HomePage";
import AdminLayout from "../Layout/AdminLayout";
import CheckoutPage from "../Pages/CheckoutPage";
import SignUpPage from "../Pages/SignUpPage";
import ResourceManagement from "../Pages/ResourceManagement";
import StateManagement from "../Pages/StateManagement";
import AreaManagement from "../Pages/AreaManagement";
import SlotManagement from "../Pages/SlotManagement";
import CalendarManagement from "../Pages/CalendarManagement";
import ProfileLayout from "../Layout/ProfileLayout";
import ProfilePage from "../Pages/ProfilePage";
import BookingsPage from "../Pages/BookingsPage";
import BookingDetails from "../Pages/BookingDetails";
import AddressPage from "../Pages/AddressPage";
import FrequencyManagement from "../Pages/FrequencyManagement";
import NoOfResourceManagement from "../Pages/NoOfResourceManagement";
import RequestManagement from "../Pages/RequestManagement";
import PriceManagement from "../Pages/PriceManagement";
import ChargesManagement from "../Pages/ChargesManagement";
import NoOfHrsManagement from "../Pages/NoOfHrsManagement";
import UserRoleManagement from "../Pages/UserRoleManagement";
import PrivilegeManagement from "../Pages/PrivilegeManagement";
import BrPrivMapping from "../Pages/BrPrivMapping";
import CommentsManagement from "../Pages/CommentsManagement";
import Contact from "../Pages/contact";
import Services from "../Pages/services";
import AboutUs from "../Pages/aboutUs";
import NotificationManagement from "../Pages/NotificationManagement";

const PageRoutes = () => (
    <Routes>
        <Route path="/register" element={<SignUpPage />} />
        <Route path="/" element={
            <MainLayout />
        }>
            <Route index element={<HomePage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route path="/reset-password/:token/:email" element={<ResetPassword  />} />
            {/* user profile routes */}
            <Route path="/profile" element={
                <UserRoute>
                    <ProfileLayout />
                </UserRoute>
            }>
                <Route path="overview" element={<ProfilePage />} />
                <Route path="requests" element={<BookingsPage />} />
                <Route path="address" element={<AddressPage />} />
                <Route path="/profile/requests/:reqId" element={<BookingDetails/>} />
            </Route>
        </Route>
        <Route path="/checkout/:category" element={<CheckoutPage />} />
        {/* admin dashboard routes */}
        <Route path="/admin" element={
            <UserRoute>
                <AdminLayout />
            </UserRoute>
        }>
            <Route path="user" element={<UserManagement />} />
            <Route path="category" element={<CategoryManagement />} />
            <Route path="resource" element={<ResourceManagement />} />
            <Route path="state" element={<StateManagement />} />
            <Route path="area" element={<AreaManagement />} />
            <Route path="calendar" element={<CalendarManagement />} />
            <Route path="slot" element={<SlotManagement />} />
            <Route path="charges" element={<ChargesManagement />} />
            <Route path="frequency" element={<FrequencyManagement />} />
            <Route path="no-of-hrs" element={<NoOfHrsManagement />} />
            <Route path="no-of-res" element={<NoOfResourceManagement />} />
            <Route path="price-table" element={<PriceManagement />} />
            <Route path="offer" element={<OfferManagement />} />
            <Route path="coupon" element={<CouponManagement />} />
            <Route path="request" element={<RequestManagement />} />
            <Route path="br" element={<UserRoleManagement />} />
            <Route path="privilege" element={<PrivilegeManagement />} />
            <Route path="br-priv-mapping" element={<BrPrivMapping />} />
            <Route path="comments" element={<CommentsManagement />} />
            <Route path="notification" element={<NotificationManagement />} />
        </Route>
    </Routes>
);

export default PageRoutes;